import { app, Component, payload, ojs, state, v } from "modular-openscriptjs";
import { dom } from "../../../fotastart";
import { pageInfo, redirect, either, getStore, store } from "../../../helpers";
import { PAGES, api, dc, gc } from "../../../declarations";
import SolidIcon from "../../Blocks/SolidIcon";
import Spinner from "../../Blocks/Spinner";
import CheckYesno from "../../Blocks/CheckYesno";
import { $e } from "../../../ojs.events";
import BsIcon from "../../Blocks/BsIcon";

const h = app("h");
const broker = app("broker");

ojs(SolidIcon, Spinner, CheckYesno, BsIcon);

export default class Register extends Component {
    step = state(1);
    totalSteps = 3;
    handleAvailable = state(null); // null: unknown, true: available, false: taken
    customerShare = state(0);
    termsAccepted = state(false);
    shouldGenerateOrderAudio = state(false);
    debounceTimer = null;

    formData = {
        name: "",
        handle: "",
        description: "",
        support_email: gc?.user?.email,
        support_phone: gc?.user?.phone,
        support_link: gc?.user?.phone
            ? `https://wa.me/254${gc.user.phone.replace(/\D/g, "").slice(-9)}`
            : "",
        commission_rate: 15,
        customer_commission_rate: 0,
        should_generate_order_audio: false,
    };

    render() {
        pageInfo("Register My Business");
        scrollToTop();

        return h.div(
            { class: "min-vh-100 py-5 mb-5 py-md-5" },
            h.div(
                { class: "container" },
                h.div(
                    { class: "row justify-content-center" },
                    h.div(
                        { class: "col-md-8 col-lg-6" },
                        h.div(
                            {
                                class: "card border-0 shadow-sm p-4 p-md-5",
                                style: "border-radius: 20px;",
                            },

                            // Header
                            h.div(
                                { class: "text-center mb-4" },
                                h.h2(
                                    { class: "fw-bold mb-2" },
                                    "Register Your Business",
                                ),
                                h.p(
                                    { class: "text-muted" },
                                    v(
                                        this.step,
                                        (s) =>
                                            `Step ${s.value} of ${this.totalSteps}`,
                                    ),
                                ),
                            ),

                            // progress bar
                            v(
                                this.step,
                                (s) =>
                                    h.div({
                                        class: "progress-bar bg-primary h-100 progress-bar-striped progress-bar-animated",
                                        role: "progressbar",
                                        style: `width: ${
                                            (s.value / this.totalSteps) * 100
                                        }%;`,
                                    }),
                                {
                                    $class: "d-block",
                                    class: "progress mb-4 d-block",
                                    style: "height: 8px; border-radius: 4px;",
                                },
                            ),

                            // Form Content
                            v(this.step, (s) => {
                                switch (s.value) {
                                    case 1:
                                        return this.renderStep1();
                                    case 2:
                                        return this.renderStep2();
                                    case 3:
                                        return this.renderStep3();
                                    default:
                                        return null;
                                }
                            }),

                            // Navigation Buttons
                            h.div(
                                {
                                    class: "d-flex justify-content-between mt-5",
                                },
                                h.button(
                                    {
                                        class: "btn btn-outline-secondary rounded-pill d-flex align-items-center justify-content-between",
                                        onclick: this.method("prevStep"),
                                        style: v(this.step, (s) =>
                                            s.value === 1
                                                ? "visibility: hidden;"
                                                : "",
                                        ),
                                    },
                                    h.SolidIcon("chevron-left"),
                                    h.span("Back"),
                                ),
                                h.button(
                                    {
                                        class: "btn btn-primary rounded-pill d-flex align-items-center justify-content-between",
                                        onclick: this.method("nextStep", [
                                            "${this}",
                                        ]),
                                    },
                                    v(this.step, (s) =>
                                        s.value === this.totalSteps
                                            ? h.span("Register Business")
                                            : h.span("Next"),
                                    ),
                                    h.SolidIcon("chevron-right"),
                                ),
                            ),
                        ),
                    ),
                ),
            ),
        );
    }

    renderStep1() {
        return h.div(
            { class: "d-grid gap-3" },
            h.h5({ class: "fw-bold" }, "Basic Information"),
            this.renderInput(
                "name",
                "Business Name",
                "e.g. Acme Corp",
                "text",
                null,
                null,
                "Your public business name.",
            ),
            this.renderInput(
                "handle",
                "Business Handle (Username)",
                "e.g. acmecorp",
                "text",
                "@",
                this.method("checkHandleAvailability", ["${this}"]),
                "Your unique business username.",
            ),
            this.renderTextarea(
                "description",
                "Business Description",
                "Briefly describe what you sell",
                "A short overview of your products or services.",
            ),
        );
    }

    renderStep2() {
        return h.div(
            { class: "d-grid gap-3" },
            h.h5({ class: "fw-bold" }, "Support Contact"),
            this.renderInput(
                "support_email",
                "Support Email",
                "support@example.com",
                "email",
                null,
                null,
                "For customer inquiries.",
            ),
            this.renderInput(
                "support_phone",
                "Support Phone",
                "+2547xxxxxxxx",
                "tel",
                null,
                null,
                "Customers use this to contact you.",
            ),
            this.renderInput(
                "support_link",
                "Website/Support Link",
                "https://example.com",
                "url",
                null,
                null,
                h.span(
                    {},
                    "WhatsApp or chat link. Get your WhatsApp link ",
                    h.a(
                        {
                            href: "https://create.wa.link/",
                            target: "_blank",
                            class: "text-primary text-decoration-none",
                        },
                        "here",
                    ),
                    ".",
                ),
            ),
        );
    }

    renderStep3() {
        return h.div(
            { class: "d-grid gap-3" },
            h.h5({ class: "fw-bold" }, "Commission & Terms"),
            h.div(
                { class: "mb-3" },
                h.label(
                    {
                        class: "form-label fw-bold mb-3 small text-uppercase text-muted",
                    },
                    "Carata Commission (Total 15%)",
                ),
                h.div(
                    { class: "row g-3 mb-3" },
                    h.div(
                        { class: "col-6" },
                        h.div(
                            {
                                class: "card border shadow-sm text-center p-3 h-100 bg-white",
                                style: "border-radius: 12px;",
                            },
                            h.i({
                                class: "bi bi-person-fill text-warning fs-3 mb-1",
                            }),
                            h.div(
                                { class: "text-muted small" },
                                "Customer Pays",
                            ),
                            h.div(
                                { class: "fw-bold fs-5 text-dark" },
                                v(this.customerShare, (cs) => `${cs.value}%`),
                            ),
                        ),
                    ),
                    h.div(
                        { class: "col-6" },
                        h.div(
                            {
                                class: "card border shadow-sm text-center p-3 h-100 bg-white",
                                style: "border-radius: 12px;",
                            },
                            h.i({
                                class: "bi bi-briefcase-fill text-primary fs-3 mb-1",
                            }),
                            h.div(
                                { class: "text-muted small" },
                                "Business Pays",
                            ),
                            h.div(
                                { class: "fw-bold fs-5 text-dark" },
                                v(
                                    this.customerShare,
                                    (cs) => `${15 - cs.value}%`,
                                ),
                            ),
                        ),
                    ),
                ),
                h.div(
                    {
                        class: "card border shadow-sm p-3 mb-3 bg-white",
                        style: "border-radius: 12px;",
                    },
                    v(this.customerShare, (cs) => {
                        const leftPct = (cs.value / 7) * 100;
                        return h.div(
                            {
                                class: "position-relative py-4 my-2 user-select-none ruler-track",
                                style: "cursor: pointer;",
                                onmousedown: this.method("startDrag", [
                                    "${event}",
                                ]),
                                ontouchstart: this.method("startDrag", [
                                    "${event}",
                                ]),
                            },
                            // Track line
                            h.div({
                                class: "w-100 bg-secondary opacity-25 position-absolute start-0 end-0",
                                style: "height: 2px; top: 50%; transform: translateY(-50%);",
                            }),
                            // Ticks
                            h.div(
                                {
                                    class: "d-flex justify-content-between w-100 position-absolute start-0 end-0",
                                    style: "top: 50%; transform: translateY(-50%); height: 16px; pointer-events: none;",
                                },
                                ...Array.from({ length: 8 }).map((_, i) =>
                                    h.div({
                                        class: "border-start border-secondary opacity-50",
                                        style: `height: ${i === 0 || i === 7 ? "16px" : "8px"}; transform: translateY(${i === 0 || i === 7 ? "-8px" : "-4px"});`,
                                    }),
                                ),
                            ),
                            // Tick Labels
                            h.div(
                                {
                                    class: "d-flex justify-content-between w-100 position-absolute start-0 end-0 small text-muted",
                                    style: "top: 70%; pointer-events: none; font-size: 10px;",
                                },
                                ...Array.from({ length: 8 }).map((_, i) =>
                                    h.span(
                                        {
                                            class: "text-center",
                                            style: "width: 20px; margin-left: -10px; margin-right: -10px;",
                                        },
                                        `${i}%`,
                                    ),
                                ),
                            ),
                            // Vertical Indicator Bar
                            h.div({
                                class: "bg-blue position-absolute rounded",
                                style: `width: 6px; height: 32px; top: 50%; transform: translate(-50%, -50%); left: ${leftPct}%; transition: left 0.05s ease-out;`,
                            }),
                        );
                    }),
                ),
                h.div(
                    { class: "form-text small text-muted text-center mb-2" },
                    "Slide to adjust how commission is paid.",
                ),
                h.div(
                    {
                        class: "alert alert-info py-2 px-3 small d-flex align-items-start gap-2 mt-2",
                        style: "border-radius: 8px; border: 1px solid rgba(13, 202, 240, 0.2);",
                    },
                    h.i({
                        class: "bi bi-info-circle-fill text-info fs-6 mt-1",
                    }),
                    h.span(
                        {},
                        `Commission split applies to all prices above ${dc.userCurrency} 150. The higher the customer share, the higher your prices will be on the App.`,
                    ),
                ),
            ),
            v(this.shouldGenerateOrderAudio, (s) =>
                h.div(
                    { class: "mb-3" },
                    h.label(
                        {
                            class: "form-label fw-bold mb-2 small text-uppercase text-muted d-flex align-items-center gap-2",
                        },
                        h.i({ class: "bi bi-stars text-primary" }),
                        "AI Features",
                    ),
                    h.div(
                        {
                            class: "p-4 rounded-4 bg-white border position-relative overflow-hidden",
                            style: "animation: rotatingGlow 4s linear infinite; transition: all 0.3s ease;",
                        },
                        h.style(`
                        @keyframes rotatingGlow {
                            0% {
                                box-shadow: 0 0 15px rgba(128, 0, 128, 0.6), inset 0 0 10px rgba(255, 215, 0, 0.2);
                                border-color: #800080;
                            }
                            25% {
                                box-shadow: 0 0 15px rgba(255, 215, 0, 0.6), inset 0 0 10px rgba(0, 123, 255, 0.2);
                                border-color: #ffd700;
                            }
                            50% {
                                box-shadow: 0 0 15px rgba(0, 123, 255, 0.6), inset 0 0 10px rgba(220, 53, 69, 0.2);
                                border-color: #007bff;
                            }
                            75% {
                                box-shadow: 0 0 15px rgba(220, 53, 69, 0.6), inset 0 0 10px rgba(128, 0, 128, 0.2);
                                border-color: #dc3545;
                            }
                            100% {
                                box-shadow: 0 0 15px rgba(128, 0, 128, 0.6), inset 0 0 10px rgba(255, 215, 0, 0.2);
                                border-color: #800080;
                            }
                        }
                    `),
                        h.CheckYesno(
                            {
                                id: "should_generate_order_audio",
                                checked: s?.value ?? false,
                                label: {
                                    value: h.span(
                                        h.BsIcon("volume-up-fill", {
                                            class: "text-blue",
                                        }),
                                        h.span("Listen to Orders"),
                                        {
                                            class: "d-inline-flex gap-2 align-items-center",
                                        },
                                    ),
                                    bolder: true,
                                },
                                helpText: {
                                    value: "We will use your AI credits to generate the audio version of each order so that you can listen to what was ordered on the go.",
                                    class: "text-secondary mt-1 d-block fw-normal",
                                },
                                onchange: this.method("setAudioGeneration", [
                                    "${this}",
                                ]),
                            },
                            {
                                class: "check-yesno-end d-flex justify-content-between align-items-center w-100 m-0",
                            },
                        ),
                    ),
                ),
            ),
            h.div(
                { class: "form-check" },
                h.input(
                    {
                        class: "form-check-input",
                        type: "checkbox",
                        id: "termsAccepted",
                        listeners: {
                            change: (e) =>
                                (this.termsAccepted.value = e.target.checked),
                        },
                    },
                    either(this.termsAccepted.value, { checked: true }),
                ),
                h.label(
                    { class: "form-check-label small", for: "termsAccepted" },
                    "I agree to ",
                    h.a(
                        {
                            href: "https://carata.co/business-terms-and-conditions/",
                            target: "_blank",
                            class: "text-primary text-decoration-none",
                        },
                        "Carata terms of service for business",
                    ),
                ),
            ),
        );
    }

    renderTextarea(name, label, placeholder, helpText = null) {
        return h[`ojs-${name}`](
            { class: "d-block" },
            h.div(
                { class: "form-field" },
                h.label(
                    {
                        class: "form-label fw-600 small text-uppercase text-muted mb-1",
                    },
                    label,
                ),
                h.textarea({
                    class: "form-control bg-light border-0",
                    value: this.formData[name],
                    listeners: {
                        input: (e) => {
                            this.formData[name] = e.target.value;
                        },
                    },
                    placeholder: placeholder,
                    style: "padding: 0.75rem 1rem;",
                    rows: 3,
                }),
                either(helpText, () =>
                    h.div(
                        { class: "form-text small text-muted mt-1" },
                        helpText,
                    ),
                ),
            ),
        );
    }

    renderInput(
        name,
        label,
        placeholder,
        type = "text",
        prefix = null,
        oninput = null,
        helpText = null,
    ) {
        return h[`ojs-${name}`](
            { class: "d-block" },
            h.div(
                { class: "form-field" },
                h.label(
                    {
                        class: "form-label fw-600 small text-uppercase text-muted mb-1",
                    },
                    label,
                ),
                h.div(
                    { class: "input-group" },
                    either(prefix, () =>
                        h.span(
                            {
                                class: "input-group-text bg-light border-0 pe-1 text-muted",
                            },
                            prefix,
                        ),
                    ),
                    h.input(
                        {
                            class: "form-control bg-light border-0",
                            type: type,
                            value: this.formData[name],
                            listeners: {
                                input: (e) => {
                                    if (name === "handle") {
                                        e.target.value = e.target.value
                                            .toLowerCase()
                                            .replace(/[^a-z0-9._-]/g, "");
                                    }
                                    this.formData[name] = e.target.value;
                                },
                            },
                            placeholder: placeholder,
                            style: "padding: 0.75rem 1rem;",
                        },
                        either(oninput, { oninput: oninput }),
                    ),
                    either(name === "handle", () =>
                        v(this.handleAvailable, (available) => {
                            if (available.value === true) {
                                return h.span(
                                    {
                                        class: "input-group-text bg-light border-0 text-success h-100",
                                    },
                                    h.i({ class: "bi bi-check-circle-fill" }),
                                );
                            }
                            if (available.value === false) {
                                return h.span(
                                    {
                                        class: "input-group-text bg-light border-0 text-danger h-100",
                                    },
                                    h.i({ class: "bi bi-x-circle-fill" }),
                                );
                            }
                            if (available.value === "processing") {
                                return h.Spinner({
                                    class: "input-group-text bg-light border-0 h-100",
                                });
                            }
                            return null;
                        }),
                    ),
                ),
                either(helpText, () =>
                    h.div(
                        { class: "form-text small text-muted mt-1" },
                        helpText,
                    ),
                ),
            ),
        );
    }

    startDrag(e) {
        e.preventDefault();
        const isTouch = e.type.startsWith("touch");
        const startX = isTouch ? e.touches[0].clientX : e.clientX;

        const track = e.currentTarget.classList.contains("ruler-track")
            ? e.currentTarget
            : e.currentTarget.closest(".ruler-track");
        if (!track) return;

        const rect = track.getBoundingClientRect();

        const updateVal = (clientX) => {
            let offset = clientX - rect.left;
            let pct = offset / rect.width;
            pct = Math.max(0, Math.min(1.0, pct)); // clamp between 0% and 100%

            const customerVal = Math.round(pct * 7);
            const val = 15 - customerVal;

            this.customerShare.value = customerVal;
            this.formData.customer_commission_rate = customerVal;
            this.formData.commission_rate = val;
        };

        updateVal(startX);

        const onMove = (moveEvent) => {
            const clientX = moveEvent.type.startsWith("touch")
                ? moveEvent.touches[0].clientX
                : moveEvent.clientX;
            updateVal(clientX);
        };

        const onEnd = () => {
            document.removeEventListener("mousemove", onMove);
            document.removeEventListener("mouseup", onEnd);
            document.removeEventListener("touchmove", onMove);
            document.removeEventListener("touchend", onEnd);
        };

        document.addEventListener("mousemove", onMove);
        document.addEventListener("mouseup", onEnd);
        document.addEventListener("touchmove", onMove, { passive: true });
        document.addEventListener("touchend", onEnd);
    }

    checkHandleAvailability(target) {
        target.value = target.value.toLowerCase().replace(/[^a-z0-9._-]/g, "");
        const handle = target.value;
        this.handleAvailable.value = null;

        if (!handle || handle.length < 3) return;
        this.handleAvailable.value = "processing";

        if (this.debounceTimer) clearTimeout(this.debounceTimer);

        this.debounceTimer = setTimeout(async () => {
            try {
                const res = await api.get(`companies/check-availability`, {
                    handle: handle,
                });
                if (res) {
                    this.handleAvailable.value = res.data.available;
                }
            } catch (e) {
                console.error(e);
            }
        }, 500);
    }

    setAudioGeneration(elem) {
        this.shouldGenerateOrderAudio.value = elem.checked;
        this.formData.should_generate_order_audio = elem.checked;
    }

    nextStep(btn) {
        if (this.step.value < this.totalSteps) {
            this.step.value++;
        } else {
            this.submit(btn);
        }
    }

    prevStep() {
        if (this.step.value > 1) {
            this.step.value--;
        }
    }

    async submit(btn) {
        if (!this.formData.name) {
            this.step.value = 1;
            return app("inform")("Please enter your business name.", "warning");
        }

        if (this.handleAvailable.value !== true) {
            this.step.value = 1;
            return app("inform")(
                "Please choose an available business handle.",
                "warning",
            );
        }

        if (!this.formData.description) {
            this.step.value = 1;
            return app("inform")(
                "Please briefly describe what you sell.",
                "warning",
            );
        }

        if (!this.formData.support_phone) {
            this.step.value = 2;
            return app("inform")(
                "Please enter a support phone number.",
                "warning",
            );
        }

        if (!this.termsAccepted.value) {
            this.step.value = 3;
            return app("inform")(
                "Please accept the terms of service to continue.",
                "warning",
            );
        }

        dom.disable(btn);
        dom.empty(btn);
        h.Spinner({ parent: btn });

        try {
            const res = await api.post("companies", this.formData);

            if (res) {
                app("inform")("Business registered successfully!", "success");
                this.selectCompany(res.data.company);
            }
        } catch (e) {
            console.error(e);
            app("inform")(
                "Failed to register business. Please try again.",
                "error",
            );
            this.step.value = 1;
        } finally {
            dom.enable(btn);
            dom.empty(btn);
            h.span("Register Business", { parent: btn, resetParent: true });
            h.SolidIcon("chevron-right", { parent: btn });
        }
    }

    async selectCompany(company) {
        let previousCompany =
            (await getStore("current_company")) || window.currentCompany;

        window.currentCompany = company;
        await store("current_company", company);
        app("inform")(`Switched to ${company.name}`, "success");

        app("broker").send(
            $e.company.has.changed,
            payload({
                previous: previousCompany,
                current: company,
            }),
        );

        redirect().to("home");
    }
}

ojs(Register);
